module.exports = require("@mui/material/Slide");